import MiscUtils from './MiscUtils'

const AlgoliaUtils = {

  getCredentials() {
    if (MiscUtils.STAGE === 'dev') {
      return {
        appId: 'VVBGPUK45J',
        apiKey: 'b24a22bed9d8b6ed3dce2e7385eb8adf'
      }
    } else if (MiscUtils.STAGE === 'prod') {
      return {
        appId: 'ZPR7723H69',
        apiKey: 'e96e3aab2981e97b593d0c5a496be615'
      }
    }
  }
}

export default AlgoliaUtils



// WEBPACK FOOTER //
// ./src/infra/AlgoliaUtils.js